import { render, staticRenderFns } from "./StudyProgramGroup.vue?vue&type=template&id=04e7d673&"
import script from "./StudyProgramGroup.vue?vue&type=script&lang=js&"
export * from "./StudyProgramGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports